<aza-rws-table
    class="multi-registration__table"
    [data$]="data$"
    [rowActionGetter]="rowActionGetter"
    [extraRowDivTemplate]="extraRowDivTemplate"
    [rowClassNamesGetter]="rowClassNamesGetter"
>
    <div
        aza-rws-table-no-data-template
        class="multi-registration__table__empty aza-horizontal-stack aza-vertical-items-centered aza-flex-centered"
    >
        {{ TRANSLATION_MAP.MULTI_REGISTRATION_TABLE_EMPTY | translate }}
    </div>
</aza-rws-table>
